import { useContext } from 'react';
import { useFeatureTableSessionCache } from '../FeatureTableSessionCacheProvider';
import { FeatureTableDataCacheContext } from './FeatureTableDataCache';
export const useBuyingMotionProps = () => {
  const {
    sessionCacheKey
  } = useFeatureTableSessionCache();
  const {
    cachedBuyingMotionProps
  } = useContext(FeatureTableDataCacheContext);
  return cachedBuyingMotionProps.sessionCache[sessionCacheKey];
};
export const useFeatureCategories = () => {
  const {
    sessionCacheKey
  } = useFeatureTableSessionCache();
  const {
    cachedFeatureCategories
  } = useContext(FeatureTableDataCacheContext);
  return cachedFeatureCategories.sessionCache[sessionCacheKey];
};
export const useIsPreSeatsPortal = () => {
  const {
    isPreSeatsPortal
  } = useContext(FeatureTableDataCacheContext);
  return isPreSeatsPortal;
};
export const useIsPublicUseCase = () => {
  const {
    isPublicUseCase
  } = useContext(FeatureTableDataCacheContext);
  return isPublicUseCase;
};
export const useOwnedHubTierWithinSkuCategory = () => {
  var _cachedOwnedProductsW;
  const {
    sessionCacheKey
  } = useFeatureTableSessionCache();
  const {
    cachedOwnedProductsWithinSkuCategory
  } = useContext(FeatureTableDataCacheContext);
  return (_cachedOwnedProductsW = cachedOwnedProductsWithinSkuCategory.sessionCache) === null || _cachedOwnedProductsW === void 0 ? void 0 : _cachedOwnedProductsW[sessionCacheKey];
};
export const useAllOwnedProducts = () => {
  const {
    cachedOwnedProductsWithinSkuCategory
  } = useContext(FeatureTableDataCacheContext);
  return cachedOwnedProductsWithinSkuCategory.allOwnedProducts;
};
export const useCurrencyAndPurchaseOptions = () => {
  const {
    sessionCacheKey
  } = useFeatureTableSessionCache();
  const {
    cachedPrices
  } = useContext(FeatureTableDataCacheContext);
  return cachedPrices.sessionCache[sessionCacheKey];
};
export const useProducts = () => {
  const {
    sessionCacheKey
  } = useFeatureTableSessionCache();
  const {
    cachedProducts
  } = useContext(FeatureTableDataCacheContext);
  return cachedProducts.sessionCache[sessionCacheKey];
};
export const usePurchaseMotions = () => {
  const {
    sessionCacheKey
  } = useFeatureTableSessionCache();
  const {
    cachedPurchaseMotions
  } = useContext(FeatureTableDataCacheContext);
  return cachedPurchaseMotions.sessionCache[sessionCacheKey];
};
export const useCachedCurrency = () => {
  const {
    cachedCurrency
  } = useContext(FeatureTableDataCacheContext);
  return cachedCurrency;
};